<template>
  <div class="fb_post">

    <header class="fb_post-header">
      <a :href="'fb://page/' + page.id"><img :src="page.picture.data.url" alt=""></a>
      <span class="page_title">{{ page.name }}</span>
      <span class="fb_post-created">{{ data.created_time | dateFormat( 'd.F Y' ) }}</span>
    </header>

    <div class="fb_post-content" v-show="data.message">
      <p v-html="data.message"></p>
    </div>


    <div v-if="data.attachments.data[0].type === 'album'" class="fb_post-embed">
      <h2 v-html="data.attachments.data[0].title"></h2>
      <div v-html="data.attachments.data[0].description"></div>
      <figure v-if="!hasGallery">
        <img :src="data.attachments.data[0].media.image.src"
             :width="data.attachments.data[0].media.image.width"
             :height="data.attachments.data[0].media.image.height"
             alt="" />
      </figure>
    <figure class="fb_post-gallery" v-else-if="hasGallery">
        <a :href="img.target.url" target="_blank" v-for='(img,idx) in data.attachments.data[0].subattachments.data' v-bind:key="idx">
            <img :src="img.media.image.src" :width="img.media.image.width" :height="img.media.image.height" alt="" /></a>
    </figure>
    </div>

    <template v-else-if="data.type === 'video' && youtubeId !== null">
      <div class="video-wrap">
        <youtube class="block-video" :player-vars="{showinfo : false}"
                 :video-id="youtubeId" ref="youtube"></youtube>
      </div>
    </template>

    <template v-else-if="data.attachments.data[0].type === 'video' || data.attachments.data[0].type === 'video_autoplay'">
      <img :src="data.attachments.data[0].media.image.src" alt="">
    </template>

    <template v-else>

      <figure v-if="hasImage && ! hasGallery" class="fb_post-banner">
        <a :href="postLink">
          <img :src="image.src" :width="image.width" :height="image.height"
          /></a>
      </figure>

      <figure class="fb_post-gallery" v-else-if="hasGallery">
        <a :href="img.target.url" target="_blank" v-for='(img,idx) in gallery' v-bind:key="idx">
          <img :src="img.media.image.src" alt=""></a>
      </figure>

    </template>

  </div>
</template>

<script>

  export default {
    name: "Post",
    data() {
      return {
        video: {}
      };
    },
    props: {
      data: {
        type: Object,
        required: true
      },
      page: {
        type: Object,
        required: false
      }
    },
    computed: {
      image: function () {

        let attachments = this.data.attachments.data;

        if ( attachments[ 0 ].type === 'album' || attachments[ 0 ].type === 'new_album' ) {
          return attachments[ 0 ].subattachments.data[ 0 ].media.image;
        }
        else {
          return attachments[ 0 ].media.image;
        }

      },
      hasImage: function () {
        return this.data.attachments.data.length === 1;
      },
      gallery: function () {
        let attachments = this.data.attachments.data;

        if ( attachments[ 0 ].type === 'album' || attachments[ 0 ].type === 'new_album' ) {

          return attachments[ 0 ].subattachments.data;
        }

      },
      hasGallery: function () {
        let attachments = this.data.attachments.data;

        return (attachments[ 0 ].type === 'album');
      },
      youtubeId: function () {

        if ( this.data.hasOwnProperty('source') ) {
          if ( this.data.source.match(/youtube/) ) {
            let id = this.data.source.match(/[a-zA-Z0-9_-]{11}/);
            // console.log('id:', id);
            return id[ 0 ];
          }
        }
        return null;
      },
      postLink: function () {
        return '//www.facebook.com/' + this.page.id + '/posts/' + this.data.id.split('_')[ 1 ];
      }
    },
    methods: {},
    created() {
      if ( this.data.type === 'video' && !this.data.hasOwnProperty('source') ) {

        FB.api(
          '/' + this.data.id,
          'GET',
          {
            access_token: this.$parent.access_token,
            fields: 'source,message,id,link,full_picture'
          },
          function ( response ) {

            this.thumbnail = response.full_picture;
            // 	url: false
            // };


            if ( response.hasOwnProperty('source') ) {
              this.url = response.source;
            }


            // return (videoData);

          }.bind(this.video));

      }
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/plugins/Facebook/Post.vue